import { FC } from "react";

import { ICard } from "../../../interfaces";
import { FrontSide } from "../../atoms";

interface CardSlotMachineProps {
    cardData?: ICard
    onClick(): void
}

const CardSlotMachine: FC<CardSlotMachineProps> = (props) => {
    const { cardData, onClick } = props; 

    return (
        <div className={`unLocked position_relative`} style={{background: "transparent"}} onMouseDown={onClick}>
            {cardData && <FrontSide cardData={cardData}/>}
        </div>
    );
};

export default CardSlotMachine;